import QUERY from 'lodash'

export default {

  data () {
    return {
      requesterSignatory: {
        stage: 0,
        approver_label: 'Warehouse Officer - Origin',
        approver_action: 'Stock Transfer',
        approver_name: '',
        last_seen: '',
        status: 'Requested',
        status_at: '',
        remarks: ''
      },
      canceledSignatory: {
        stage: 1,
        approver_label: 'Warehouse Officer - Origin',
        approver_action: 'Cancellation',
        approver_name: '',
        last_seen: '',
        status: 'Canceled',
        status_at: '',
        remarks: ''
      }
    }
  },

  computed: {
    SubmitRequestAsDraftButton () {
      if (this.editing) {
        return 'Update Draft'
      }

      return 'Save Draft'
    }
  },

  methods: {

    vTabStockRequest () {
      if (this.$refs.formStockRequest) {
        return Object.keys(this.$refs.formStockRequest.errors).find(
          key => this.$refs.formStockRequest.errors[key]?.length > 0
        )
      }

      return false
    },

    vTabProducts () {
      if (this.$refs.formProducts) {
        return Object.keys(this.$refs.formProducts.errors).find(
          key => this.$refs.formProducts.errors[key]?.length > 0
        )
      }

      return false
    },

    vTabDeliveryDetails () {
      if (this.$refs.formDelivery) {
        return Object.keys(this.$refs.formDelivery.errors).find(
          key => this.$refs.formDelivery.errors[key]?.length > 0
        )
      }

      return false
    },

    showRequest (stockRequest, editAsDraft = true) {
      this.editing = true
      this.editAsDraft = editAsDraft

      const { headers, delivery_details, details } = stockRequest

      this.editable.is3pl = String(delivery_details?.is_3pl) || 0

      this.getProducts(this).finally(() => {
        this.stockRequest = Object.assign(this.stockRequest, {
          id: stockRequest.id,
          stage: 0,
          references: {
            document_number: '',
            transfer_number: '',
            sap_doc_entry: '',
            transaction_number: ''
          },
          headers: {
            withdrawal: headers.withdrawal,
            withdrawal_transaction_number: headers.withdrawal_transaction_number,
            destination: '',
            destination_name: '',
            destination_code: ''
          },
          delivery_details: {
            date: delivery_details?.date || '',
            vehicle: delivery_details?.vehicle || '',
            vehicle_plate: delivery_details?.vehicle_plate || '',
            vehicle_name: delivery_details?.vehicle_name || '',
            driver: delivery_details?.driver || '',
            driver_name: delivery_details?.driver_name || '',
            mobile_number: delivery_details?.mobile_number || '',
            is_3pl: delivery_details?.is_3pl || 0,
            helper: delivery_details?.helper || ''
          },
          details: details.map(
            detail => Object.assign(detail, {
              product: QUERY.find(this.options.products, {
                product_code: detail.product_code
              })
            })
          ),
          approvals: [],
          remarks: headers.remarks,
          created_at: ''
        })

        this.getDestinations(this).finally(() => {
          this.selected.destination = QUERY.find(this.options.destinations, {
            id: headers.destination
          }) || ''

          if (Number(delivery_details?.is_3pl) === 0) {
            this.getDrivers(this).finally(() => {
              this.selected.driver = QUERY.find(this.options.drivers, {
                id: delivery_details?.driver || ''
              }) || ''
            })

            this.getVehicles(this).finally(() => {
              this.selected.vehicle = QUERY.find(this.options.vehicles, {
                id: delivery_details?.vehicle || ''
              }) || ''
            })
          } else {
            this.selected.driver = ''
            this.selected.vehicle = ''
          }
        })

        this.$refs.srDraft.loaded()
        this.$bvModal.show('modalRequest')
      })
    },

    showRequestPreview (stockRequest) {
      const { delivery_details } = stockRequest

      this.editable.is3pl = String(delivery_details?.is_3pl) || 0

      this.stockRequest = Object.assign(this.stockRequest, {
        id: stockRequest.id,
        stage: stockRequest.stage,
        references: {
          document_number: stockRequest.document_number,
          transfer_number: stockRequest.transfer_number,
          sap_doc_entry: stockRequest.sap_doc_entry,
          transaction_number: stockRequest.transaction_number
        },
        headers: {
          withdrawal: stockRequest.withdrawal_id || '',
          withdrawal_transaction_number: stockRequest.withdrawal_transaction_number,
          destination: stockRequest.destination_id,
          destination_code: stockRequest.destination_code,
          destination_name: stockRequest.destination_name
        },
        delivery_details: {
          date: delivery_details?.date || '',
          vehicle: delivery_details?.vehicle || '',
          vehicle_plate: delivery_details?.vehicle_plate || '',
          vehicle_name: delivery_details?.vehicle_name || '',
          driver: delivery_details?.driver || '',
          driver_name: delivery_details?.driver_name || '',
          mobile_number: delivery_details?.mobile_number || '',
          logistics_type: Number(delivery_details?.is_3pl) === 1 ? '3rd Party' : 'In-House',
          is_3pl: delivery_details?.is_3pl || 0,
          helper: delivery_details?.helper || ''
        },
        details: stockRequest.transfer_details,
        approvals: stockRequest.approvals,
        remarks: stockRequest.remarks,
        created_at: stockRequest.created_at
      })

      this.requesterSignatory = Object.assign(this.requesterSignatory, {
        approver_name: stockRequest.origin_name,
        status_at: stockRequest.created_at
      })

      this.canceledSignatory = Object.assign(this.canceledSignatory, {
        approver_name: stockRequest.origin_name,
        remarks: stockRequest.canceled_remarks,
        status: stockRequest.status,
        status_at: stockRequest.canceled_at
      })

      this.$bvModal.show('modalRequestPreview')
    }
  }
}
